import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "[&>*:last-child]:border-b-0 [&>*:last-child]:pb-0" }

import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'

import SettingsSection from '@/components/neue/SettingsSection.vue'
import NotificationRow from '@/components/settings/NotificationRow'
import { clearPushPrompted, isMobileDevice, usePushNotifications } from '@/composables/usePushNotifications'
import { useSettingsAccess } from '@/composables/useSettingsAccess'
import { useToast } from '@/composables/useToast'
import api from '@/store/api'
import SettingsShell from '@/view/settings/SettingsShell.vue'


export default {
  __name: 'SettingsNotifications',
  setup(__props) {

const store = useStore()
const { canEditEmails, currentUserEmail } = useSettingsAccess()
const { subscribe: subscribePush } = usePushNotifications()
const { showToast } = useToast()

const notifications = computed(() => Object.values(store.state.objects?.notification ?? {}))
const activeNotificationsCount = computed(() => notifications.value.filter(n => n.attributes.is_active).length)
const description = computed(() => {
  const intro = 'Choose which events you hear about and how. Click an email to change who receives it.'
  if (!notifications.value.length) return intro
  return `${intro} ${activeNotificationsCount.value} of ${notifications.value.length} active.`
})

const updateNotification = async (notification, attrs) => {
  try {
    await api.call('PUT', `notifications/${notification.id}`, { notification: attrs })
    showToast('Notification settings saved')
  } catch {
    showToast("Couldn't save that change. Please try again.", { type: 'error' })
  }
}

const requestPushPermission = () => {
  if (!isMobileDevice) return
  subscribePush()
}

const onDisablePush = () => {
  clearPushPrompted(store.state.loggedInUser?.id)
}

onMounted(() => api.call('GET', 'notifications'))

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SettingsShell, null, {
    default: _withCtx(() => [
      _createVNode(SettingsSection, {
        title: "Notifications",
        description: description.value
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "hidden md:grid grid-cols-[minmax(0,1fr)_minmax(10rem,14rem)_auto] gap-6 text-xs font-semibold uppercase text-gray-500 border-b border-gray-200 pb-2" }, [
              _createElementVNode("div", null, "Event"),
              _createElementVNode("div", null, "Channels"),
              _createElementVNode("div", null, "On/Off")
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (notification) => {
              return (_openBlock(), _createBlock(_unref(NotificationRow), {
                key: notification.id,
                notification: notification,
                "current-user-email": _unref(currentUserEmail),
                "can-edit-emails": _unref(canEditEmails),
                onUpdate: attrs => updateNotification(notification, attrs),
                onRequestPushPermission: requestPushPermission,
                onDisablePush: onDisablePush
              }, null, 8, ["notification", "current-user-email", "can-edit-emails", "onUpdate"]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["description"])
    ]),
    _: 1
  }))
}
}

}